(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ph-header"]) return;
  try {
    
document.addEventListener('click',event=>{if(event.target.closest('.ph-mobile-menu nav a'))event.target.closest('details').removeAttribute('open')});
document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.ph-mobile-menu[open]').forEach(menu=>{menu.removeAttribute('open');menu.querySelector('summary').focus()})});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ph-product"]) return;
  try {
    
document.addEventListener('click',event=>{
const link=event.target.closest('[data-variant-id]');
if(!link||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey||event.button!==0)return;
const root=link.closest('[data-product-section]');if(!root)return;
event.preventDefault();const data=link.dataset;
root.querySelectorAll('[data-variant-id]').forEach(item=>item.removeAttribute('aria-current'));
link.setAttribute('aria-current','true');root.querySelector('[data-variant-input]').value=data.variantId;root.querySelector('[data-variant-title]').textContent=data.title;root.querySelector('[data-price]').textContent=data.price;
const compare=root.querySelector('[data-compare]');compare.textContent=data.compare;compare.hidden=!data.compare;
const add=root.querySelector('[data-add]');add.disabled=data.buyable!=='true';add.textContent=data.button;
const quantity=root.querySelector('[data-quantity]');quantity.min=data.min;quantity.step=data.step;if(data.max)quantity.max=data.max;else quantity.removeAttribute('max');
const min=Number(data.min)||1,step=Number(data.step)||1,max=Number(data.max)||Infinity;const desired=Math.max(min,Math.min(Number(quantity.value)||min,max));quantity.value=String(min+Math.floor((desired-min)/step)*step);
const mockup=root.querySelector('.ph-product-main-image [data-spool-image]');if(mockup&&data.mockupUrl)mockup.setAttribute('href',data.mockupUrl);
const photo=root.querySelector('.ph-product-photo');if(photo&&data.image){photo.src=data.image;photo.removeAttribute('srcset');photo.alt=data.alt||data.title;}
root.querySelector('[data-variant-status]').textContent=data.title+' — '+data.price+' — '+data.button;
const url=new URL(window.location.href);url.searchParams.set('variant',data.variantId);history.replaceState({},'',url);
root.dispatchEvent(new CustomEvent('printhaus:variant-changed',{bubbles:true}));
});

  } catch(e) { console.error(e); }
})();
})();
